import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../../Core/Container';

export const StyledContainer = styled(Container)`
  margin: 0;
  width: 100%;
`;

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};
`;

export const TableTitle = styled.div`
  display: flex;
  padding-bottom: 1.5rem;
  p {
    font-size: 1.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding-bottom: 2rem;
  }
`;

export const TableRow = styled.div`
  display: flex;
  flex-direction: column;

  &:nth-child(even) {
    background-color: #f2f2f2;
    border-radius: 0.25rem;
  }

  &:nth-child(odd) {
    background-color: transparent;
  }

  &:first-child {
    vertical-align: middle;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const TableCell = styled.div`
  padding: 0.75rem 2rem;
  width: 100%;
  align-self: center;
  p {
    width: 100% !important;
  }
  &:first-child {
    padding-bottom: 0;
    p {
      font-size: 1.25rem;
      text-align: center;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 1.5rem 2rem;
    width: 33.333%;

    &:first-child {
      padding-bottom: 1.5rem;
      p {
        text-align: left;
      }
    }

    &:last-child {
      width: 66.666%;
    }
  }
`;
